import React from "react";
import DraggableContainer from "./draggableContainer";
import SettingsComponent from "./settingsComponent";
import StatusRow from "./receiveStatComponent";
import ReceiveStatComponent from "./receiveStatComponent";
import SendAudioComponent from "./sendAudioComponent";
import SendScoreComponent from "./sendScoreComponent";
import PleaseDownloadComponent from './pleaseDownloadComponent';
import StreamReceiveComponent from './streamReceiveComponent';
import StreamSendComponent from './streamSendComponent';
import TimerComponent from "./timerComponent";
import WebRTCComponent from "./webRTCComponent";
import InstructionComponent from "./instructionComponent";

const NewComponent = ({ titleName, showing, handleHide, port, handleShowReceiveStat }) => {
  if (titleName == "Settings")
    return (
      <DraggableContainer
        titleName={"Settings"}
        showing={showing}
        handleHide={handleHide}
      >
        <SettingsComponent handleShowReceiveStat={handleShowReceiveStat}></SettingsComponent>
      </DraggableContainer>
    );
  if (titleName == "sendAudioFile")
    return (
      <DraggableContainer
        titleName={"Send Audio File"}
        showing={true}
        handleHide={handleHide}
      >
        <SendAudioComponent port={port}></SendAudioComponent>
      </DraggableContainer>
    );
  if (titleName == "sendStatLights")
    return (
      <DraggableContainer
        titleName={"Send Stats"}
        showing={showing}
        handleHide={handleHide}
      >
        Send Stats
      </DraggableContainer>
    );
  if (titleName == "sendScore")
    return (
      <DraggableContainer
        titleName={"Send a Score"}
        showing={true}
        handleHide={handleHide}
      >
        <SendScoreComponent port={port} />
      </DraggableContainer>
    );
  if (titleName == "receiveStatLights")
    return (
      <DraggableContainer
        titleName={"Receive Stats"}
        showing={showing}
        handleHide={handleHide}
      >
        <ReceiveStatComponent></ReceiveStatComponent>
      </DraggableContainer>
    );
  if (titleName == "PleaseDownloadComponent")
    return (
      <DraggableContainer
        titleName={"Welcome to SoundMesh"}
        showing={showing}
        handleHide={handleHide}
      >
        <PleaseDownloadComponent></PleaseDownloadComponent>
      </DraggableContainer>
    );
  if (titleName == "StreamReceiveComponent")
    return (
      <DraggableContainer
        titleName={"Stream Receive"}
        showing={showing}
        handleHide={handleHide}
      >
        <StreamReceiveComponent></StreamReceiveComponent>
      </DraggableContainer>
    );
  if (titleName == "StreamSendComponent")
    return (
      <DraggableContainer
        titleName={"Stream Send"}
        showing={showing}
        handleHide={handleHide}
      >
        <StreamSendComponent></StreamSendComponent>
      </DraggableContainer>
    );
    if (titleName == "TimerComponent")
    return (
      <DraggableContainer
        titleName={"Timer"}
        showing={showing}
        handleHide={handleHide}
      >
        <TimerComponent></TimerComponent>
      </DraggableContainer>
    );
    if (titleName == "WebRTCComponent")
    return (
      <DraggableContainer
        titleName={"Streaming"}
        showing={true}
        handleHide={handleHide}
      >
        <WebRTCComponent></WebRTCComponent>
      </DraggableContainer>
    );
    if (titleName == "InstructionComponent")
    return (
      <DraggableContainer
        titleName={"Instruction"}
        showing={showing}
        handleHide={handleHide}
      >
        <InstructionComponent></InstructionComponent>
      </DraggableContainer>
    );
};

export default NewComponent;
